;(function () {
  'use strict'

  angular
    .module('contrast.integrations')
    .factory('BugtrackerService', [
      'BugtrackerFactory',
      'ServiceUtils',
      BugtrackerService
    ])

  function BugtrackerService(BugtrackerFactory, ServiceUtils) {
    return {
      getBugtrackers: getBugtrackers,
      getBugtrackersByApplications: getBugtrackersByApplications,
      deleteBugtracker: deleteBugtracker
    }

    function getBugtrackers() {
      return BugtrackerFactory.getBugtrackers()
        .then(ServiceUtils.handleResolve('data'))
        .catch(ServiceUtils.handleError)
    }

    function getBugtrackersByApplications(applications) {
      return BugtrackerFactory.getBugtrackersByApplications(applications)
        .then(ServiceUtils.handleResolve('data.bugtrackers'))
        .catch(ServiceUtils.handleError)
    }

    function deleteBugtracker(id) {
      return BugtrackerFactory.deleteBugtracker(id)
    }
  }
})()
